var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRequiredRole)?_c('div',{staticClass:"my-ski-row my-5"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","offset-xl":"3","xl":"7","offset-lg":"3","lg":"9"}},[_vm._t("default")],2)],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }